import { CSSProperties, forwardRef, PropsWithChildren, UIEvent } from 'react';

interface IProps {
  style?: CSSProperties;
  onEndReached?: () => void;
}

export const ScrollArea = forwardRef<HTMLDivElement, PropsWithChildren<IProps>>(
  ({ children, style = {}, onEndReached }, ref) => {
    const onScroll = (e: UIEvent<HTMLDivElement>) => {
      const target = e.currentTarget;
      const isAtBottom = Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) < 1;

      if (isAtBottom && onEndReached) {
        onEndReached();
      }
    };

    return (
      <div
        ref={ref}
        style={{
          overflow: 'auto',
          position: 'relative',
          width: '100%',
          ...style,
        }}
        onScroll={onScroll}
      >
        {children}
      </div>
    );
  },
);

ScrollArea.displayName = 'ScrollArea';
